/* assets/size-guide-modal.js
   Construye el boton + modal de la guia de talla completamente por JS,
   leyendo los datos desde <script id="size-guide-data"> (impreso en
   layout/theme.liquid). No depende de ningun snippet del producto, para
   no interferir con variant-picker.liquid ni main-product.liquid. */

(function () {
  var MEASURE_LABELS = {
    bicicleta: 'Estatura (cm)',
    cabeza_cm: 'Circunferencia de cabeza (cm)',
    mano_cm: 'Contorno de mano (cm)',
    rodilla_cm: 'Circunferencia de rodilla (cm)',
    tobillo_cm: 'Circunferencia de tobillo (cm)',
    pie_cm: 'Largo de pie (cm)'
  };

  var WHATSAPP_NUMBER = '56996729802';

  function buildWhatsAppLink(productTitle, value, matches) {
    var msg = 'Hola! Estaba viendo *' + productTitle + '* y tengo una duda con la talla.';
    if (matches.length === 2) {
      msg += ' Según mi medida (' + value + ' cm) estoy entre la talla ' + matches[0].talla +
        ' y la ' + matches[1].talla + ', ¿me pueden ayudar a elegir?';
    } else if (matches.length === 1) {
      msg += ' Mi medida es ' + value + ' cm, me recomendaron la talla ' + matches[0].talla +
        ', ¿podrían confirmarme?';
    } else if (value) {
      msg += ' Mi medida es ' + value + ' cm, ¿me pueden ayudar a elegir la talla correcta?';
    }
    return 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent(msg);
  }

  function minMaxKeys(kind) {
    if (kind === 'bicicleta') return { min: 'estatura_min', max: 'estatura_max' };
    return { min: 'medida_min', max: 'medida_max' };
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function buildModalHTML(data) {
    var isMulti = data.kind === 'multi';
    var hasImage = !!data.image;

    var rightColumn =
      '<h3 class="size-guide-modal__title">' + escapeHtml(data.product) + '</h3>' +
      '<p class="size-guide-modal__subtitle">' +
        (isMulti ? 'Compara tus medidas con la tabla para encontrar tu talla.' : 'Dinos tu medida y te ayudamos a encontrar tu talla ideal.') +
      '</p>' +
      (isMulti ? '' :
        '<div class="size-guide-modal__input-row">' +
          '<label data-size-guide-input-label>' + (MEASURE_LABELS[data.kind] || 'Medida (cm)') + '</label>' +
          '<input type="number" class="size-guide-modal__input" min="1" max="400" step="0.5" data-size-guide-height />' +
        '</div>'
      ) +
      '<div class="size-guide-modal__result" data-size-guide-result></div>' +
      '<div class="size-guide-modal__table" data-size-guide-table></div>' +
      (data.help ? '<p class="size-guide-modal__help">' + escapeHtml(data.help).replace(/\n/g, '<br>') + '</p>' : '') +
      '<p class="size-guide-modal__contact">¿Tienes dudas? <a href="https://wa.me/' + WHATSAPP_NUMBER + '" target="_blank" rel="noopener" data-size-guide-whatsapp>Escríbenos por WhatsApp</a></p>';

    if (hasImage) {
      return (
        '<div class="size-guide-modal" data-size-guide-modal hidden>' +
          '<div class="size-guide-modal__backdrop" data-size-guide-close></div>' +
          '<div class="size-guide-modal__panel size-guide-modal__panel--split" role="dialog" aria-modal="true">' +
            '<button type="button" class="size-guide-modal__close" data-size-guide-close aria-label="Cerrar guía de tallas">&times;</button>' +
            '<div class="size-guide-modal__image-col"><img src="' + data.image + '" alt="Cómo medir" loading="lazy"></div>' +
            '<div class="size-guide-modal__content-col">' + rightColumn + '</div>' +
          '</div>' +
        '</div>'
      );
    }

    return (
      '<div class="size-guide-modal" data-size-guide-modal hidden>' +
        '<div class="size-guide-modal__backdrop" data-size-guide-close></div>' +
        '<div class="size-guide-modal__panel" role="dialog" aria-modal="true">' +
          '<button type="button" class="size-guide-modal__close" data-size-guide-close aria-label="Cerrar guía de tallas">&times;</button>' +
          rightColumn +
        '</div>' +
      '</div>'
    );
  }

  function renderMultiTable(tableBox, resultBox, rows) {
    if (resultBox) resultBox.innerHTML = 'Compara tus medidas de pecho, cintura y cadera con la tabla.';
    tableBox.innerHTML =
      '<div class="size-guide-modal__multi-row size-guide-modal__multi-head">' +
        '<span>Talla</span><span>Pecho</span><span>Cintura</span><span>Cadera</span>' +
      '</div>' +
      rows.map(function (s) {
        return (
          '<div class="size-guide-modal__multi-row">' +
            '<span>' + s.talla + '</span>' +
            '<span>' + s.pecho_min + '-' + s.pecho_max + '</span>' +
            '<span>' + s.cintura_min + '-' + s.cintura_max + '</span>' +
            '<span>' + s.cadera_min + '-' + s.cadera_max + '</span>' +
          '</div>'
        );
      }).join('');
  }

  function init() {
    var dataScript = document.getElementById('size-guide-data');
    var targetContainer = document.querySelector('.product-options');
    if (!dataScript || !targetContainer) return;

    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    if (!data || !data.rows || !data.rows.length) return;

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'size-guide-trigger';
    trigger.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 12h18M3 6h18M3 18h18"/></svg> Guía de tallas';
    targetContainer.appendChild(trigger);

    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildModalHTML(data);
    var modal = wrapper.firstElementChild;
    document.body.appendChild(modal);

    var closers = modal.querySelectorAll('[data-size-guide-close]');
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }
    closers.forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    var rows = data.rows;

    if (data.kind === 'multi') {
      var tableBox = modal.querySelector('[data-size-guide-table]');
      var resultBox = modal.querySelector('[data-size-guide-result]');
      renderMultiTable(tableBox, resultBox, rows);
      var whatsappLink = modal.querySelector('[data-size-guide-whatsapp]');
      if (whatsappLink) whatsappLink.href = buildWhatsAppLink(data.product, null, []);
      trigger.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      var observerMulti = new MutationObserver(function () {
        if (!document.body.contains(trigger)) {
          var container = document.querySelector('.product-options');
          if (container) container.appendChild(trigger);
        }
      });
      observerMulti.observe(document.body, { childList: true, subtree: true });
      return;
    }

    var keys = minMaxKeys(data.kind);
    var heightInput = modal.querySelector('[data-size-guide-height]');
    var resultBox2 = modal.querySelector('[data-size-guide-result]');
    var tableBox2 = modal.querySelector('[data-size-guide-table]');
    var whatsappLink2 = modal.querySelector('[data-size-guide-whatsapp]');

    var globalMin = Math.min.apply(null, rows.map(function (s) { return s[keys.min]; }));
    var globalMax = Math.max.apply(null, rows.map(function (s) { return s[keys.max]; }));
    var sorted = rows.slice().sort(function (a, b) { return a[keys.min] - b[keys.min]; });
    var isPointBased = sorted.every(function (s) { return s[keys.min] === s[keys.max]; });

    function renderPointsTable(matches) {
      tableBox2.innerHTML = sorted.map(function (s) {
        var isMatch = matches.some(function (m) { return m.talla === s.talla; });
        return (
          '<div class="size-guide-modal__table-row size-guide-modal__table-row--point' + (isMatch ? ' is-match' : '') + '">' +
            '<span class="size-guide-modal__size-label' + (isMatch ? ' is-match' : '') + '">' + s.talla + '</span>' +
            '<span class="size-guide-modal__point-value">' + s[keys.min] + ' cm</span>' +
          '</div>'
        );
      }).join('');
    }

    function renderTable(matches) {
      tableBox2.innerHTML = rows.map(function (s) {
        var isMatch = matches.some(function (m) { return m.talla === s.talla; });
        var leftPct = ((s[keys.min] - globalMin) / (globalMax - globalMin)) * 100;
        var widthPct = ((s[keys.max] - s[keys.min]) / (globalMax - globalMin)) * 100;
        return (
          '<div class="size-guide-modal__table-row' + (isMatch ? ' is-match' : '') + '">' +
            '<span class="size-guide-modal__size-label' + (isMatch ? ' is-match' : '') + '">' + s.talla + '</span>' +
            '<div class="size-guide-modal__bar-row">' +
              '<span class="size-guide-modal__bar-num">' + s[keys.min] + ' cm</span>' +
              '<div class="size-guide-modal__bar-track">' +
                '<div class="size-guide-modal__bar-fill" style="left:' + leftPct + '%;width:' + widthPct + '%;"></div>' +
              '</div>' +
              '<span class="size-guide-modal__bar-num">' + s[keys.max] + ' cm</span>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    function recommend(value) {
      if (!value || value < 1 || value > 400) {
        resultBox2.innerHTML = '<span style="color:#c0392b;">Ingresa una medida válida.</span>';
        renderTable([]);
        return;
      }

      if (isPointBased) {
        var chosenPoint = null;
        for (var p = 0; p < sorted.length; p++) {
          if (sorted[p][keys.min] >= value) {
            chosenPoint = sorted[p];
            break;
          }
        }
        if (!chosenPoint) {
          chosenPoint = sorted[sorted.length - 1];
          resultBox2.innerHTML =
            'Tu medida supera nuestra talla más grande disponible. La más cercana es <b>' +
            chosenPoint.talla + '</b> (' + chosenPoint[keys.min] + ' cm), te recomendamos confirmar con nosotros antes de comprar.';
        } else {
          resultBox2.innerHTML =
            'Te sugerimos la talla <b>' + chosenPoint.talla + '</b> (' + chosenPoint[keys.min] + ' cm).';
        }
        renderPointsTable([chosenPoint]);
        if (whatsappLink2) whatsappLink2.href = buildWhatsAppLink(data.product, value, [chosenPoint]);
        return;
      }

      var matches = sorted.filter(function (s) {
        return value >= s[keys.min] && value <= s[keys.max];
      });

      if (matches.length === 0 && value >= globalMin && value <= globalMax) {
        for (var i = 0; i < sorted.length - 1; i++) {
          if (value > sorted[i][keys.max] && value < sorted[i + 1][keys.min]) {
            matches = [sorted[i], sorted[i + 1]];
            break;
          }
        }
      }

      if (matches.length === 1) {
        var s = matches[0];
        resultBox2.innerHTML =
          'Te sugerimos la talla <b>' + s.talla + '</b>, que se ajusta bien de ' +
          s[keys.min] + ' a ' + s[keys.max] + ' cm.';
      } else if (matches.length >= 2) {
        var a = matches[0], b = matches[1];
        if (data.kind === 'bicicleta') {
          resultBox2.innerHTML =
            'Estás entre las tallas <b>' + a.talla + '</b> y <b>' + b.talla + '</b>.<br>' +
            '<span style="font-size:13px;color:#6b6b6b;">' +
            a.talla + ': Reach más corto, geometría más reactiva e intuitiva.<br>' +
            b.talla + ': Reach más largo, mayor estabilidad y confianza a alta velocidad.' +
            '</span>';
        } else {
          resultBox2.innerHTML =
            'Estás entre las tallas <b>' + a.talla + '</b> y <b>' + b.talla + '</b>. ' +
            'Si puedes, prueba ambas antes de decidir.';
        }
      } else {
        var nearest = value < globalMin ? sorted[0] : sorted[sorted.length - 1];
        resultBox2.innerHTML =
          'Tu medida está fuera de nuestro rango estándar. La talla más cercana es <b>' +
          nearest.talla + '</b>, pero te recomendamos confirmar con nosotros antes de comprar.';
        matches = [nearest];
      }
      renderTable(matches);
      if (whatsappLink2) whatsappLink2.href = buildWhatsAppLink(data.product, value, matches);
    }

    trigger.addEventListener('click', function () {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (!heightInput.value) heightInput.value = Math.round((globalMin + globalMax) / 2);
      recommend(parseFloat(heightInput.value));
      heightInput.focus();
    });
    heightInput.addEventListener('input', function () {
      recommend(parseFloat(heightInput.value));
    });

    // El tema vuelve a dibujar .product-options al cambiar de variante
    // (para actualizar precio/disponibilidad), lo que borra nuestro botón.
    // Este observer lo vuelve a insertar automáticamente cada vez que eso pasa.
    var observer = new MutationObserver(function () {
      if (!document.body.contains(trigger)) {
        var container = document.querySelector('.product-options');
        if (container) container.appendChild(trigger);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
